/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './edit-site.scss';

/* eslint-disable import/no-unresolved, import/default */

import editSiteTemplate from './edit-site.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.admin.editSite', [])
    .directive('agEditSite', EditSite)
    .name;

/*@ngInject*/
function EditSite() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '='
        },
        controller: EditSiteController,
        controllerAs: 'vm',
        templateUrl: editSiteTemplate
    };
}

/* eslint-disable angular/angularelement */


/*@ngInject*/
function EditSiteController($rootScope, $scope, $timeout, $translate, agTypes, userService, siteService) {

    let vm = this;

    vm.showData = userService.getAuthority() === 'TENANT_ADMIN';
    vm.site = null;

    vm.gotoSiteDetails = gotoSiteDetails;
    vm.save = save;
    vm.cancel = cancel;

    var defaultTitle = $translate.instant(agTypes.assetTypeTranslatePrefix + '.' + agTypes.assetType.site) + '';

    $scope.$watch('vm.ctx', function() {
        if (vm.showData && vm.ctx) {
            vm.isEdit = vm.ctx.isEdit;
            vm.ctx.widgetTitle = defaultTitle;
            if (vm.ctx.stateController) {
                var siteId = vm.ctx.stateController.getStateParams().entityId;
                if (siteId) {
                    loadSite(siteId);
                }
            }
        }
    });

    $scope.$watch(function() { return vm.site ? vm.site.name : defaultTitle; }, function(title) {
        if (vm.showData && vm.ctx) {
            vm.ctx.widgetTitle = title;
        }
    });

    $scope.$on('editModeChanged', function() {
        vm.isEdit = vm.ctx.isEdit;
    });

    $scope.$on('siteSelected', function(event, siteId) {
        if (vm.showData) {
            if (!vm.site || !angular.equals(vm.site.id, siteId)) {
                vm.loading = true;
                vm.origSite = null;
                vm.site = null;
                loadSite(siteId);
            }
        }
    });

    $scope.$on('siteAssetPositionUpdated', function(event, siteAsset, site) {
        if (vm.showData) {
            if (vm.site && angular.equals(vm.site.id, siteAsset.id)) {
                if(!site.useGoogleMaps) {
                    vm.site.positionX = siteAsset.positionX;
                    vm.site.positionY = siteAsset.positionY;
                } else {
                    vm.site.latitude = siteAsset.latitude;
                    vm.site.longitude = siteAsset.longitude;
                }
                if (vm.origSite) {
                    if(!site.useGoogleMaps) {
                        vm.origSite.positionX = siteAsset.positionX;
                        vm.origSite.positionY = siteAsset.positionY;
                    } else {
                        vm.origSite.latitude = siteAsset.latitude;
                        vm.origSite.longitude = siteAsset.longitude;
                    }
                }
            }
        }
    });

    function loadSite(siteId) {
        vm.loading = true;
        vm.origSite = null;
        vm.site = null;
        if (siteId) {
            siteService.getSite(siteId).then(
                function success(site) {
                    vm.origSite = site;
                    vm.site = angular.copy(site);
                    vm.loading = false;
                    resetFormState();
                }
            );
        } else {
            vm.loading = false;
        }
    }

    function resetFormState() {
        $timeout(function() {
            $scope.theForm.updateValidity();
            $scope.theForm.$setPristine();
            $scope.theForm.$setUntouched();
        });
    }

    function gotoSiteDetails($event) {
        if ($event) {
            $event.stopPropagation();
        }
        var params = {
            entityId: vm.site.id
        };
        vm.ctx.stateController.openState(agTypes.adminState.site, params);
    }

    function cancel() {
        vm.site = angular.copy(vm.origSite);
        resetFormState();
    }

    function save() {
        if ($scope.theForm.updateValidity()) {
            siteService.saveSite(vm.site).then(function success(site) {
                vm.origSite = site;
                vm.site = angular.copy(site);
                $scope.theForm.$setPristine();
                $scope.theForm.$setUntouched();
                $rootScope.$broadcast('siteUpdated', vm.origSite);
            });
        }
    }

}

